import React from 'react';
import {useDispatch, useSelector} from "react-redux";
import SidebarLogo from "./SidebarLogo";
import SidebarNav from "./SidebarNav";
import SidebarFooter from "./SidebarFooter";
import Stack from "../ui/Stack";
import {useNavigate} from "react-router-dom";
import {logout} from "../../store/auth-slice";
import Button from "../common/button/Button";
import {changeShowMenu} from "../../store/utility-slice";
import Icon from "../ui/Icon";

const Sidebar = () => {
    const showMenu = useSelector(state => state.utility.showMenu);
    const navigate= useNavigate();
    const dispatch = useDispatch();

    const logoutHandler = () => {
        dispatch(logout());
        navigate("/login");
    }

    return (<>
        <aside
            className={`sidebar${showMenu ? " show" : ''} d-flex flex-column min-vh-100 p-5 vh-100 overflow-auto position-sticky top-0`}>
            <Button className="mb-2 ms-auto menu-close rounded-pill d-block d-md-none bg-primary bg-opacity-10 p-1" onClick={()=>dispatch(changeShowMenu())}>
                <Icon name="cross" width="24px" fill="gray"/>
            </Button>
            <SidebarLogo/>
            <Stack className="flex-grow-1">
                <SidebarNav onLogout={logoutHandler}/>
            </Stack>
            <SidebarFooter/>
        </aside>
    </>)
};

export default Sidebar;
